import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AppointmentErrorMessages } from '@src/constants';
import { SlotsSearchResponseV4 } from '@src/lib/__generated/api';
import { useGlobalUXStore } from '@src/store';
import restfulClient from '@src/utils/restfulClient';

export async function fetchSlots(params: Record<string, any>) {
	const path = `v4/facilities/${params.facilityCode}/slots`;
	const route = path;

	try {
		const clientResponse: SlotsSearchResponseV4[] = await restfulClient.post({ route, data: params });

		return clientResponse;
	} catch (error) {
		if (error instanceof AxiosError) {
			if (error.response?.status === 503) {
				useGlobalUXStore.getState().openDialogWithError(AppointmentErrorMessages.statusCode503);
			}
			throw new Error(error.message);
		} else {
			throw new Error('Failed to fetch slots');
		}
	}
}

export function useGetSlots(params: Record<string, any>) {
	const { error, isPending, data } = useQuery<SlotsSearchResponseV4[], Error>({
		queryKey: ['getSlots', { params }],
		queryFn: () => fetchSlots(params),
		enabled: !!params.facilityCode,
	});
	return { error, isPending, data };
}
